import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { MainAppStoreModule } from "./main-app-store/main-app-store.module";
import { KwikspaceAppStoreModule } from "./kwikspace-app-store/kwikspace-app-store.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false
      }
    }),
    EffectsModule.forRoot([]),
    MainAppStoreModule,
    KwikspaceAppStoreModule
  ],
})
export class RootStoreModule { }
